import React from "react";
import { cn } from "@/lib/utils";
import { usePrice } from "@/hooks/usePrice";
import { isUndefined } from "lodash";
import { useBinancePrices } from "@/hooks/useBinancePrices";
import numeral from "numeral";

export function Price() {
  const { data: priceData } = usePrice();
  const { data: prices } = useBinancePrices();

  if (isUndefined(priceData) || isUndefined(prices)) {
    return null;
  }

  const price = priceData.data["3tNPxTMS1ETgXeLFTjZTbt6KVbMnXU3Qtz9dwWLWtks5"];

  const formattedPrice = numeral(price).format("0.00a") || 0;
  const btcPrice = numeral(prices["BTCUSDT"]?.price).format("0.00a") || 0;

  return (
    <div
      className={cn("text-xxs flex items-start justify-start cursor-pointer")}
    >
      <div
        className="flex items-center gap-4"
        onClick={(e) => {
          e.stopPropagation();
          window.open("https://spreadfighter.link/dexscreener", "_blank");
        }}
      >
        <div className="flex flex-col gap-0.5">
          <div className="flex items-center justify-between gap-4">
            <span>BTCUSDT</span>
            <span className="text-right text-[#3CA64B]">${btcPrice}</span>
          </div>
          <div className="flex items-center justify-between gap-4">
            <span>SFUSDT</span>
            <span className="text-right text-[#3CA64B]">${formattedPrice}</span>
          </div>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            window.open("https://spreadfighter.link/token", "_blank");
          }}
          className="bg-[#3CA64B] text-white py-2 px-4 rounded-md text-xxs font-medium"
        >
          BUY TOKEN
        </button>
      </div>
    </div>
  );
}
